const SolcitudeBtnDocumentation = ({ eventoClick } : any) => {
    return (
        <div className='solicitude-button-documentation' onClick={eventoClick}>Documentación</div>
    );
};

export default SolcitudeBtnDocumentation;